import i18n from 'helpers/i18n';
import { useEffect, useId, useRef } from 'react';
import messages from './messages';
import useAsync from 'hooks/useAsync';
import { verifyPhone } from 'actions/sms';
import { Button } from '@teachstonellc/component-library';
import {
  Formik,
  Form,
  Input,
  PreventNavigation
} from 'components/EnhancedForm';
import { ErrorMessage, ButtonWrapper, InputWrapper } from './Styled';
import { FormikHelpers } from 'formik';

interface SmsCodeFormProps {
  /** Callback fired when the verification code is successfully verified. */
  onSucess: () => void;
}

function SmsCodeForm({ onSucess }: SmsCodeFormProps) {
  const { run, isLoading, isError } = useAsync();
  // `Input` doesn't forward a ref, so this points at its wrapper.
  const inputWrapperRef = useRef<HTMLDivElement>(null);
  const errorId = useId();

  useEffect(() => {
    if (isError) {
      inputWrapperRef.current?.querySelector('input')?.focus();
    }
  }, [isError]);

  function handleSubmit(values: any, formik: FormikHelpers<any>) {
    run(verifyPhone(values.code), {
      onSuccess: () => {
        formik.resetForm();
        onSucess();
      }
    });
  }

  return (
    <Formik initialValues={{ code: '' }} onSubmit={handleSubmit}>
      <Form>
        <PreventNavigation />
        <InputWrapper ref={inputWrapperRef}>
          <Input
            label={i18n.ft(messages.enterCode)}
            name="code"
            pattern="[0-9]*"
            aria-invalid={isError}
            aria-describedby={isError ? errorId : undefined}
          />
          {isError && (
            <ErrorMessage id={errorId} role="alert">
              {i18n.ft(messages.invalidCode)}
            </ErrorMessage>
          )}
        </InputWrapper>

        <ButtonWrapper>
          <Button
            type="submit"
            variant="primary"
            shape="rounded"
            disabled={isLoading}
            loading={isLoading}
          >
            {i18n.ft(messages.verify)}
          </Button>
        </ButtonWrapper>
      </Form>
    </Formik>
  );
}

export default SmsCodeForm;
